module.exports = __webpack_public_path__ + "img/iurisprudentia_Merriweather.d45c28bf.svg";